module.exports = __webpack_public_path__ + "static/media/avatar24.7a2ac954.png";